import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PropertyPricingService } from '@app/features/pricing-and-availability';
import { PricesAndFees } from '@app/shared/models/tax';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { UiModule } from '@app/ui/ui.module';

@Component({
  standalone: true,
  selector: 'sbnb-property-base-price',
  templateUrl: './property-base-price.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, UiModule],
})
export class PropertyBasePriceComponent implements OnInit {
  @Input() currency;

  public basePrice = PricesAndFees.basePrice;
  public priceSaveState$ = this.propertyDetailService.priceSaveState$;
  public pricingFeeDiscountData$ = this.propertyDetailService.pricingFeeDiscountData$;

  public basePriceSubject = new Subject<{ key: string; data: any }>();

  constructor(private readonly propertyDetailService: PropertyPricingService) {}

  ngOnInit(): void {
    this.basePriceSubject.pipe(debounceTime(300)).subscribe(({ key, data }) => {
      this.propertyDetailService.savePriceChange(key, data);
    });
  }

  savePriceChange(key: string, data: any) {
    this.basePriceSubject.next({ key, data });
  }
}
